const state = {
  perfis: []
}

const mutations = {
  SET_PERFIS(state, perfis) {
    state.perfis = perfis
  }
}

const getters = {
  perfis: state => state.perfis
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
